export default {
  BACKGROUND_FIRE: 'background_fire',
}
